import React, { useEffect, useState } from 'react';
import { parseStoryFile, type ParsedStory } from '../utils/parseStoryFile';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';


type ArchiveMeta = {
  sectionTitle: string;
  backgroundImage: string;
  introParagraph: string;
};


const Archive: React.FC = () => {
  const [stories, setStories] = useState<ParsedStory[]>([]);
  const [loading, setLoading] = useState(true);
    const [meta, setMeta] = useState<ArchiveMeta | null>(null);
    const [homeContent, setHomeContent] = useState<any>(null);

useEffect(() => {
  const loadArchive = async () => {
    try {
      // 1. Fetch archive metadata
      const metaRes = await fetch('/content/Archive.json');
      const metaData = await metaRes.json();
      console.log(metaRes);
      setMeta(metaData);
      setHomeContent(metaData)
      // 2. Fetch index of story files
      const indexRes = await fetch('/archive/list.json');
      const { stories: files } = await indexRes.json();

      // 3. Fetch & parse each story file
      const loadedStories: ParsedStory[] = await Promise.all(
        files.map(async (file: string) => {
          const res = await fetch(`/archive/${file}`);
          const text = await res.text();
          return parseStoryFile(text, file);
        })
      );

      setStories(loadedStories);
    } catch (err) {
      console.error('Error loading archive:', err);
    } finally {
      setLoading(false);
    }
  };

  loadArchive();
}, []);


  if (loading || !meta) {
  return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-logoPurple" />
            </div>
        );
}

    const { heroSection } = homeContent;

  return (
    <div className="">

      <HeroSection
                backgroundImage={heroSection.backgroundImage}
                headingText={heroSection.headingText}
                subHeadingText={heroSection.subHeadingText}
                heightSize={heroSection.heightSize}
                profileImage={heroSection.profileImage}
            />

  <div className='p-8'>
  <h1 className="text-4xl font-bold text-logoPurple text-center mb-4">
    {meta.sectionTitle}
  </h1>

  <p className="max-w-3xl mx-auto text-gray-600 text-center mb-12">
    {meta.introParagraph}
  </p>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    {stories.map((story) => {
  const CardContent = (
    <div
      className="rounded-lg shadow-lg overflow-hidden"
      style={{ background: "#F9FAFB" }}
    >
      <img
        src={story.image}
        alt={story.title}
        className="w-full h-48 object-cover"
      />

      <div className="p-6">
        <h2 className="text-xl font-bold text-logoPurple">
          {story.title}
        </h2>

        <p className="text-sm text-gray-500 mb-3">
          {story.date}
        </p>

        <p className="text-gray-600 line-clamp-1">
          {story.body}
        </p>

        <div className="mt-4">
          {story.tags &&
            story.tags.map((tag, index) => (
              <span
                key={index}
                className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2"
              >
                #{tag}
              </span>
            ))}
        </div>
      </div>
    </div>
  );

  return story.link ? (
    <a
      key={story.slug}
      href={story.link}
      target="_blank"
      rel="noopener noreferrer"
      className="block hover:scale-[1.02] transition"
    >
      {CardContent}
    </a>
  ) : (
    <Link
      key={story.slug}
      to={`/archive/${story.slug}`}
      className="block hover:scale-[1.02] transition"
    >
      {CardContent}
    </Link>
  );
})}

  </div>
  </div>
</div>

  );
};

export default Archive;
